function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_37234_40259)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M157.489 86.7254H14.7417C7.30585 86.7254 1.28516 80.6675 1.28516 73.1858V14.8335C1.28516 7.35181 7.30585 1.29395 14.7417 1.29395H144.058C151.494 1.29395 157.515 7.35181 157.515 14.8335",
  fill: "#EDF4FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.489 86.7254H14.7417C7.30585 86.7254 1.28516 80.6675 1.28516 73.1858V14.8335C1.28516 7.35181 7.30585 1.29395 14.7417 1.29395H144.058C151.494 1.29395 157.515 7.35181 157.515 14.8335",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.438 15.2217C157.438 15.2217 167.164 22.2374 172.181 39.1425C177.198 56.0476 177.584 72.2537 177.687 75.1273C177.79 78.0009 177.481 87.3983 168.45 91.5405C159.419 95.6826 147.121 99.7471 145.448 100.239C143.776 100.731 136.005 102.025 132.095 95.6826C128.184 89.34 126.974 86.777 126.974 86.777L142.798 86.078C142.798 86.078 140.637 78.5704 140.92 74.506C141.203 70.4415 144.753 62.7526 143.364 58.4034C142 54.0542 133.561 44.5014 128.801 39.4532C124.016 34.379 124.324 28.5542 128.158 24.6968C131.992 20.8395 137.498 22.0303 143.673 27.2598C149.848 32.4892 156.846 38.5212 156.846 38.5212L157.438 15.1958V15.2217Z",
  fill: "#EDF4FF",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.28516 60.4749L6.61116 56.9023C8.51514 55.6338 9.64724 53.485 9.64724 51.2069V36.8129C9.64724 34.5089 8.51514 32.386 6.61116 31.1175L1.28516 27.5449V60.5008V60.4749Z",
  fill: "#EDF4FF",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.9065 29.3576L83.2598 30.7297L84.2118 33.0079L86.7847 33.6551L87.4537 35.9591L90.5412 36.4251L90.6956 33.5256L92.0592 32.0759L90.9529 28.8398L88.1741 29.8495L84.9065 29.3576Z",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.9531 28.84L98.0802 21.1252L97.3083 13.4364L105.053 9.73438",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.541 36.4253L95.867 43.6999L95.0437 49.4471L99.5721 54.2882",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.2605 30.73L75.696 26.6137L70.7817 28.0117L67.4883 24.0249",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.0605 32.0762L107.627 34.0178",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.1747 29.8498L87.6602 19.9604",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.2122 33.0078L74.9238 37.7713",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.6599 35.9854L82.8742 42.5092L81.8965 47.6869",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.1134 29.4095L81.0996 23.1445",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.9065 29.3576L83.2598 30.7297L84.2118 33.0079L86.7847 33.6551L87.4537 35.9591L90.5412 36.4251L90.6956 33.5256L92.0592 32.0759L90.9529 28.8398L88.1741 29.8495L84.9065 29.3576Z",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.9531 28.84L98.0802 21.1252L97.3083 13.4364L105.053 9.73438",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.541 36.4253L95.867 43.6999L95.0437 49.4471L99.5721 54.2882",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.2605 30.73L75.696 26.6137L70.7817 28.0117L67.4883 24.0249",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.0605 32.0762L107.627 34.0178",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.1747 29.8498L87.6602 19.9604",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.2122 33.0078L74.9238 37.7713",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.6599 35.9854L82.8742 42.5092L81.8965 47.6869",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.1134 29.4095L81.0996 23.1445",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.10547 84.9396C8.10547 84.9396 32.3684 60.0868 34.7355 57.7569C37.1026 55.4269 43.8694 48.9031 47.7031 46.366C51.5368 43.829 62.4976 36.2696 72.5578 46.4178C82.618 56.566 74.2045 67.931 73.4841 69.1477C72.7637 70.3645 70.448 74.6878 60.6965 84.4995C60.0533 85.095 59.2299 85.8457 58.3551 86.7",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5918 67.9829C37.5918 67.9829 41.7857 70.4682 45.0791 73.7819C48.3725 77.0956 50.9197 81.3931 50.9197 81.3931",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.5469 49.4725C69.5469 49.4725 75.3103 54.6501 73.432 59.1288C71.5538 63.6075 67.9002 67.0507 64.8126 69.6913C61.7251 72.3319 56.6821 75.8268 50.0439 69.1476C43.4057 62.4684 46.7248 57.6532 47.7025 56.2811C48.6803 54.909 54.3665 48.3852 57.4797 46.4436C60.593 44.5019 64.4267 44.3207 69.5983 49.4984L69.5469 49.4725Z",
  stroke: "#1D2F41",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_37234_40259"
}, /*#__PURE__*/React.createElement("rect", {
  width: 179,
  height: 102,
  fill: "white"
})));
function SvgInstrChipCapture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 102,
    viewBox: "0 0 179 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstrChipCapture);
export default __webpack_public_path__ + "static/media/instr-chip-capture.f45aef35543e13b564fe948382adcd41.svg";
export { ForwardRef as ReactComponent };